import React from 'react';

import AccordionItem from './blocks/AccordionItem';

type Props = {
  className?: string;
  data: Array<{
    id: number;
    title: string;
    content: string;
  }>;
};

const Accordion = (props: Props) => {
  const { className, data = [] }: Props = props;

  return (
    <div className={className}>
      {data.map((item) => (
        <AccordionItem key={item.id} title={item.title} content={item.content} />
      ))}
    </div>
  );
};

export default Accordion;
